import empty from 'is-empty'
import * as mutations from '@/graphql/mutations'
import { API } from 'aws-amplify'
import { getBadgeQtyLimit as resolveBadgeQtyLimit, getOverBadgeQtyLimitItem as findOverBadgeQtyLimitItem, getBadgeQtyLimitAlert } from '@/js/badgeQtyLimit'

let firstFunc2Loading = 0
let getStoreDeliveryInfoLoading = 0
let setMyUserSeqLoading = 0
const mixinCheckedSeqQuery = {
  async mounted () {
    const vm = this
    if (this.$route.path !== undefined && this.$route.path !== '/' && this.$route.path !== '/searchMain' && this.$route.path !== '/version-check') {
      if (vm.$route.query.seq === undefined || vm.$route.query.seq === null || vm.$route.query.seq === '') {
        alert('잘못된 접근입니다.')
        vm.$router.push('/')
      } else if (vm.$route.path === '/detailProduct') {
        if (vm.$route.query.seq !== undefined && (vm.$route.query.detail === undefined || empty(vm.$route.query.detail))) {
          alert('잘못된 접근입니다.')
          vm.$router.push({path: 'storeMain', query: {seq: vm.$route.query.seq}})
        }
      } else if (vm.$route.path === '/chat' || vm.$route.path === '/productBasket' || vm.$route.path === '/paymentCard' || vm.$route.path === '/wishList') {
        if (vm.$route.query.seq === undefined) {
          alert('잘못된 접근입니다.')
          vm.$router.push({path: 'storeMain', query: {seq: vm.$route.query.seq}})
        } else {
          await vm.firstFunc2()
        }
      }
    }
  },
  methods: {
    checkSeqQuery: function () {
      const vm = this
      const { seq, eventSeq } = vm.$route.query
      if (vm.$route.path !== '/productBasket') {
        if (vm.$empty(seq) && vm.$empty(eventSeq)) {
          vm.$router.push('searchMain')
        }
      }
    },
    moveRouter: function (path, keepAlive = true) {
      const vm = this
      console.log('moveRouter :::::', path, keepAlive)
      if (path === 'detailProduct') {
        const { seq, eventSeq } = vm.$route.query
        const {barcode} = vm.$store.state.selectProduct
        vm.$router.push({path: path, query: {seq: seq, eventSeq: eventSeq, detail: barcode}, meta: {keepAlive: keepAlive}})
      } else {
        const { seq, eventSeq } = vm.$route.query
        vm.$router.push({path: path, query: {seq: seq, eventSeq: eventSeq}, meta: {keepAlive: keepAlive}})
      }
      vm.checkSeqQuery()
    },
    getStoreDeliveryInfo (storeSeq) { // 매장 배달정보 가져오기
      console.log('getStoreDeliveryInfo :::::', getStoreDeliveryInfoLoading)
      if (getStoreDeliveryInfoLoading === 1) {
        return
      } else {
        getStoreDeliveryInfoLoading = 1
      }
      const vm = this
      return new Promise((resolve, reject) => {
        if (!vm.$empty(storeSeq)) {
          vm.$axios({
            method: 'get',
            url: `https://storedelivery.sery.co.kr/${storeSeq}/store/delivery`
            // url: `http://192.168.0.2:3013/${storeSeq}/store/delivery`
          }).then((response) => {
            console.log('getStoreDeliveryInfo :::::', response.data)
            getStoreDeliveryInfoLoading = 0
            if (response.data.status === 'success') {
              vm.$store.state.storeDeliveryInfo = this.$_.cloneDeep(response.data)
              vm.$store.state.storeDeliveryInfo.ORDER_START_TIME = response.data.result.orderStartTime ? response.data.result.orderStartTime : '0000'
              vm.$store.state.storeDeliveryInfo.ORDER_END_TIME = response.data.result.orderEndTime ? response.data.result.orderEndTime : '0000'
              vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME = response.data.result.startTime
              vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME = response.data.result.endTime
              vm.$store.state.storeDeliveryInfo.PAYMENT_USE_FLAG = response.data.result.paymentUseFlag
              vm.$store.state.storeDeliveryInfo.MIN_PROMO_COST = parseInt(response.data.result.defaultList.minAmount)
              vm.$store.state.storeDeliveryInfo.DELIVERY_COST = parseInt(response.data.result.defaultList.charge)
              vm.$store.state.storeDeliveryInfo.maxDistance = vm.$empty(response.data.result.maxDistance) ? 0 : parseInt(response.data.result.maxDistance) || 0
              vm.$store.state.storeDeliveryInfo.outRangeFlag = response.data.result.outRangeFlag
            }
            resolve('success')
          }).catch(error => {
            console.log('getStoreDeliveryInfo error :::::', error)
            getStoreDeliveryInfoLoading = 0
            reject(error)
          })
        } else {
          getStoreDeliveryInfoLoading = 0
          resolve('error')
        }
      })
    },
    firstFunc2 () { // 매장정보 가져오기 (매장사진등)
      return new Promise((resolve, reject) => {
        const vm = this
        console.log('firstFunc2 :::::', firstFunc2Loading)
        if (firstFunc2Loading === 1) {
          resolve('')
          return
        } else {
          firstFunc2Loading = 1
        }
        if (vm.$route.query.seq !== null && vm.$route.query.seq !== '' && vm.$route.query.seq !== undefined) {
          vm.$axios({
            method: 'get',
            url: `${process.env.API}/getStoreInfo/store/${vm.$route.query.seq}`
            // url: `http://192.168.0.2:3005/getStoreInfo/store/${vm.$route.query.seq}`
          }).then(async (response) => {
            let storeImage
            if (response.data[0].STORE_LOGO.indexOf(',') !== -1) {
              if (response.data[0].STORE_LOGO.indexOf('sery-images') !== -1) {
                var url = response.data[0].STORE_LOGO.split(',')
                storeImage = `${process.env.imgUrl}/store/${url[1]}`
              }
            } else {
              storeImage = response.data[0].STORE_LOGO
            }
            response.data[0].STORE_LOGO = storeImage
            console.log('getStoreInfo :::::', response.data[0])
            vm.$store.commit('setStoreInfo', response.data[0])

            await vm.getStoreHourInfo()
            firstFunc2Loading = 0
            resolve(response.data[0])
          }).catch((error) => {
            console.log('getStoreInfo error :::::', error)
            firstFunc2Loading = 0
            alert('매장정보가 정상적이지 않습니다.\n주소를 다시 확인해주세요.')
            reject(error)
          })
        } else {
          console.log('getStoreInfo error ::::: no seq')
          firstFunc2Loading = 0
          resolve('no seq')
        }
      })
    },
    async setMyUserSeq () {
      console.log('setMyUserSeq :::::', setMyUserSeqLoading)
      if (setMyUserSeqLoading === 1) {
        return
      } else {
        setMyUserSeqLoading = 1
      }
      const vm = this
      let getMyUserSeq = ''
      if (!vm.$empty(vm.$cookies.get('userSeq')) ||
          !vm.$empty(vm.$cookies.get('userData'))) {
        if (!vm.$empty(vm.$cookies.get('userSeq')) && vm.$cookies.get('userSeq') !== 'undefined') {
          getMyUserSeq = vm.$cookies.get('userSeq')
        } else if (!vm.$empty(vm.$cookies.get('userData'))) {
          let userData = vm.$cookies.get('userData')
          getMyUserSeq = userData.USER_SEQ
        } else {
          getMyUserSeq = localStorage.getItem(`${vm.$route.query.seq}_userSeq`)
        }
      } else {
        getMyUserSeq = localStorage.getItem(`${vm.$route.query.seq}_userSeq`)
      }
      const getMyUserIndex = localStorage.getItem(`${vm.$route.query.seq}_userIndex`)
      if (!vm.$empty(getMyUserSeq) && getMyUserSeq !== 'undefined' && !vm.$empty(getMyUserIndex) && getMyUserIndex !== 'undefined') {
        setMyUserSeqLoading = 0
        return
      }
      const data = {
        storeSeq: vm.$route.query.seq,
        sK: 'ROOM#LIVE',
        userIndex: 1
      }
      await API.graphql({
        query: mutations.updateStoreQnaInfoTable,
        variables: { input: data }
      }).then((response) => {
        console.log('userIndex 생성 => ', response.data)
        vm.userIndex = response.data.updateStoreQnaInfoTable.userIndex
        const timeStamp = Date.now()
        const random = Math.ceil(Math.random() * 100000)
        const myUserSeq = String(timeStamp) + String(random)
        if (vm.$empty(getMyUserSeq) || getMyUserSeq === 'undefined') {
          localStorage.setItem(`${vm.$route.query.seq}_userSeq`, myUserSeq)
        } else {
          localStorage.setItem(`${vm.$route.query.seq}_userSeq`, getMyUserSeq)
        }
        if (vm.$empty(getMyUserIndex) || getMyUserIndex === 'undefined') {
          console.log('userIndex :::::', vm.userIndex)
          localStorage.setItem(`${vm.$route.query.seq}_userIndex`, vm.userIndex)
        }
        setMyUserSeqLoading = 0
      })
    },
    async getHandyVersionCheck () {
      console.log('getHandyVersionCheck :::::')
      const vm = this
      const result = await vm.$axios.get('https://ji94dcy649.execute-api.ap-northeast-2.amazonaws.com/prod/teryVersionCheck', { cache: false })
      return result
    },
    async getStoreHourInfo () {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.$axios({
          method: 'get',
          url: `https://is6cslrx75.execute-api.ap-northeast-2.amazonaws.com/${vm.$route.query.seq}`
        }).then((response) => {
          let data = []
          if (!vm.$empty(response.data)) {
            if (response.data.type0.useFlag === '1' || response.data.type0.useFlag === 1) {
              data = response.data.type0
            } else if (response.data.type1.useFlag === '1' || response.data.type1.useFlag === 1) {
              data = response.data.type1
            } else if (response.data.type2.useFlag === '1' || response.data.type2.useFlag === 1) {
              data = response.data.type2
              data.body.forEach(body => {
                if (!vm.$empty(body.dayOfWeek)) {
                  for (let i = 0; i < body.dayOfWeek.length; i++) {
                    switch (body.dayOfWeek[i]) {
                      case 0:
                        body.dayOfWeek[i] = '일'
                        break
                      case 1:
                        body.dayOfWeek[i] = '월'
                        break
                      case 2:
                        body.dayOfWeek[i] = '화'
                        break
                      case 3:
                        body.dayOfWeek[i] = '수'
                        break
                      case 4:
                        body.dayOfWeek[i] = '목'
                        break
                      case 5:
                        body.dayOfWeek[i] = '금'
                        break
                      case 6:
                        body.dayOfWeek[i] = '토'
                        break
                    }
                  }
                }
              })
            }
          } else {
            data = {
              type: 0,
              body: [{
                startDate: this.$store.state.storeInfo.START_TIME.replace(/[^0-9]/gi, ''),
                endDate: this.$store.state.storeInfo.END_TIME.replace(/[^0-9]/gi, ''),
                dayOfWeek: [0, 1, 2, 3, 4, 5, 6],
                useFlag: 1
              }]
            }
          }
          vm.$store.state.storeInfo.storeHourInfo = data
          resolve(data)
        }).catch((error) => {
          console.log('getStoreHourInfo error :::::', error)
          reject(error)
        })
      })
    },
    moveToApp () {
      const vm = this
      if (vm.$store.state.storeInfo.APP_FLAG === '1') {
        this.$gtag.event('전용앱_설치_이동', {
          event_category: this.$route.query.seq,
          event_label: this.$cookies.get('userSeq'),
          value: ''
        })
        window.open(vm.$store.state.storeInfo.APP_URL)
      } else {
        this.$gtag.event('테리문자_앱_설치_이동', {
          event_category: this.$route.query.seq,
          event_label: this.$cookies.get('userSeq'),
          value: ''
        })
        window.open(`https://tery.page.link/install`)
      }
    },
    errorImage (e) {
      e.target.src = require('@/assets/no_item_image.png')
    },
    removeKakao () {
      const vm = this
      vm.$store.commit('setKakao', false)
      setTimeout(() => {
        console.log('remove kakao :::::', this.$refs.storeMenu)
        if (this.$refs.storeMenu) {
          this.$refs.storeMenu.scrollIntoView({ behavior: 'smooth' })
        }
      }, 200)
    },
    callStore () {
      const vm = this
      document.location.href = 'tel:' + vm.$store.state.storeTel
    },
    deepcopy (obj) {
      if (obj === null || typeof obj !== 'object') return obj

      const copy = obj.constructor()

      for (const attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          copy[attr] = obj[attr]
        }
      }
      return copy
    },
    moveSeryTutorial() {
      this.$gtag.event('세리_홈_배너_선택', {
        event_category: this.$route.query.seq,
        event_label: '세리홈_배너',
        value: this.$cookies.get('userSeq'),
      });
      window.open('https://home.sery.co.kr')
      // this.moveRouter('sery', false);
    },
    moveTerysmsInstall() {
      const vm = this;
      if (vm.$store.state.storeInfo.APP_FLAG === '1') {
        this.$gtag.event('전용앱_설치_배너_선택', {
          event_category: this.$route.query.seq,
          event_label: '전용앱_설치_배너',
          value: this.$cookies.get('userSeq'),
        });
        window.open(vm.$store.state.storeInfo.APP_URL);
      } else {
        this.$gtag.event('테리문자_설치_배너_선택', {
          event_category: this.$route.query.seq,
          event_label: '테리문자_설치_배너',
          value: this.$cookies.get('userSeq'),
        });
        window.open('https://tery.kr/install');
      }
    },
    moveOnTeryMarket() {
      this.$gtag.event('온테리마켓_배너_선택', {
        event_category: this.$route.query.seq,
        event_label: '온테리마켓_배너',
        value: this.$cookies.get('userSeq'),
      });
      window.open('https://smartstore.naver.com/tery_market/products/6532540596?utm_source=home.tery.kr&utm_medium=banner&utm_id=smart-sms-to-market');
    },
    moveForm(type) {
      this.$gtag.event(`설문_배너_선택`, {
        event_category: this.$route.query.seq,
        event_label: '설문_배너',
        value: this.$cookies.get('userSeq'),
      });
      window.open('https://forms.gle/ovSWjHKK7itHDfpu6');
    },
    getBadgeQtyLimit (product) {
      return resolveBadgeQtyLimit(product)
    },
    getOverBadgeQtyLimitItem (products) {
      return findOverBadgeQtyLimitItem(products)
    },
    checkAndAlertBadgeQtyLimit (product, qty) {
      const msg = getBadgeQtyLimitAlert(product, qty)
      if (msg) {
        alert(msg)
        return false
      }
      return true
    },
    clampOrderQtyToBadgeLimit (product) {
      const limit = resolveBadgeQtyLimit(product)
      if (limit !== null && Number(product.order_qty) > limit) {
        product.order_qty = limit
        const msg = getBadgeQtyLimitAlert(product, limit + 1)
        if (msg) alert(msg)
        return true
      }
      return false
    },
  }
}

export {
  mixinCheckedSeqQuery
}



// WEBPACK FOOTER //
// ./src/mixins/index.js